import { render, staticRenderFns } from "./QuestionComments.vue?vue&type=template&id=742d0ea6&scoped=true"
import script from "./QuestionComments.vue?vue&type=script&lang=js"
export * from "./QuestionComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d0ea6",
  null
  
)

export default component.exports